import { Link } from 'react-router-dom';
import { Info, X } from 'lucide-react';

interface QueueClaimNoticeProps {
  claimId: string;
  /** Short sentence explaining why the claim is not open for review here. */
  message: string;
  onDismiss: () => void;
}

/** Non-blocking notice shown when a ?claim=<id> deep link points at a claim that is no longer in this queue. */
export function QueueClaimNotice({ claimId, message, onDismiss }: QueueClaimNoticeProps) {
  return (
    <div
      id="queue-claim-notice"
      role="status"
      className="mb-4 flex items-start gap-2 rounded-xl border border-info/30 bg-info-soft px-4 py-3 text-sm text-text"
    >
      <Info className="mt-0.5 h-4 w-4 shrink-0 text-info" />
      <p className="min-w-0 flex-1">
        {message}{' '}
        <Link to={`/claims/${claimId}`} className="font-medium text-primary underline">
          View claim
        </Link>
      </p>
      <button type="button" onClick={onDismiss} aria-label="Dismiss notice" className="shrink-0 text-text-2 hover:text-text">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
